import DoAPICall from './DoAPICall'


//Get All Analytics
export async function getAnalytics(userToken,params){
   const apiPayload = {
      httpMethod:'get',
      userToken,
      uri:'mis/analytics?dateFrom='+params.from+'&dateTo='+params.to,
      payLoad:{},
      requestOptions:{}
   }
   return await DoAPICall(apiPayload)
}

//Get payments By MNO
export async function getPaymentsByMNO(userToken,params){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'mis/paymentsbymno?from='+params.from+'&to='+params.to,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Get payments - Daily Trends
export async function getDailyTrends(userToken,params){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'mis/dailytrends?from='+params.from+'&to='+params.to,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Get payments - By District
export async function getPaymentsByDistrict(userToken,params){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'mis/paymentsbydistrict?from='+params.from+'&to='+params.to,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Get payments - Monthly Trends
export async function getMonthlyTrends(userToken,params){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'mis/monthlytrends?from='+params.from+'&to='+params.to,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}








//All Other Service Requests
export async function getServiceRequests(userToken, params){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'mis/servicerequests?from='+params.from+'&to='+params.to,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Summary Report
export async function getRequestsSummary(userToken, params){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'mis/servicerequests/summary?from='+params.from+'&to='+params.to,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}